import { createBrowserRouter } from 'react-router-dom'
import Shell from './components/Shell'
import ShelfHomePage from './pages/ShelfHomePage'
import ShelfPage from './pages/ShelfPage'
import BookPage from './pages/BookPage'
import WikiPage from './pages/WikiPage'
import NotFoundPage from './pages/NotFoundPage'
import AuditPage from './pages/AuditPage'
import AdminUsersPage from './pages/AdminUsersPage'
import AdminPermissionsPage from './pages/AdminPermissionsPage'
import AdminPendingChangesPage from './pages/AdminPendingChangesPage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Shell />,
    children: [
      { index: true, element: <ShelfHomePage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'admin/users', element: <AdminUsersPage /> },
      { path: 'admin/permissions', element: <AdminPermissionsPage /> },
      { path: 'admin/pending', element: <AdminPendingChangesPage /> },
      { path: 's/:slug', element: <ShelfPage /> },
      { path: 'b/:slug', element: <BookPage /> },
      { path: 'p/:slug', element: <WikiPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
